import React from 'react';
import { motion } from 'framer-motion';
import { ProtectedImage } from './ProtectedImage';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-88">
      {/* Background Image */}
      <motion.div initial={{
      scale: 1.05
    }} animate={{
      scale: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute inset-0" data-id="element-89">
        <div className="absolute inset-0 bg-black/45 z-10" data-id="element-90" />
        <ProtectedImage src="https://cdn.magicpatterns.com/uploads/1aaE322htboioX8b13u4Se/image.png" alt="Dubai skyline with converging highways" className="w-full h-full object-cover object-center" wrapperClassName="w-full h-full" data-id="element-91" />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-6" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.5
      }} data-id="element-93">
          <h1 className="text-white font-serif text-5xl md:text-7xl lg:text-8xl tracking-wider mb-6" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.5)'
        }} data-id="element-94">
            ALEJANDRO
            <br data-id="element-95" />
            NORIEGA
          </h1>
          <p className="text-white/90 font-sans text-[10px] md:text-xs tracking-[0.3em] uppercase mb-12" style={{
          textShadow: '0 1px 10px rgba(0,0,0,0.5)'
        }} data-id="element-96">
            Street and Fine Art Photography
          </p>
          <a href="#collections" className="inline-block border border-white/60 text-white px-8 py-3 text-[10px] md:text-xs font-medium tracking-[0.2em] uppercase transition-all hover:bg-white hover:text-charcoal hover:border-white" data-id="element-97">
            View Collections
          </a>
        </motion.div>
      </div>
    </section>;
}